<script setup>
definePage({ meta: { ...PageMeta.Quotes.Edit.Meta, pageTitle: 'Edit Quote' } })

import { useRoute } from 'vue-router'
import { useEntityPageTitle } from '@/composables/useEntityPageTitle'
import { useQuoteStore } from '@/@vxapp/Quotes/useQuoteStore'
import { useQuoteFieldRead } from '@/views/Previews/Quotes/useQuoteFieldRead'
import { Subject } from '@/@vxapp/@Enums/PHP/Auth/Ability/Subjects/DataProviders/AbilitySubject'
import QuotesEditPage from '@/views/Previews/Quotes/QuotesEditPage.vue'

const route = useRoute()
const quotesStore = useQuoteStore()

const currentQuote = () =>
  quotesStore.quote?.quoteGUID === route.params.guid ? quotesStore.quote : null

const canReadQuoteField = useQuoteFieldRead(
  currentQuote,
  () => false,
  () => Subject.QUOTES_PREVIEW_GUID
)

useEntityPageTitle({
  entityName: 'Edit Quote',
  record: () => quotesStore.quote,
  recordGuid: quote => quote.quoteGUID,
  identifier: quote => (canReadQuoteField('id') ? quote.id : null),
})

/* ** */
</script>

<template>
  <QuotesEditPage :key="route.params.guid" />
</template>
